module.exports = __webpack_public_path__ + "img/submitted-grey.901b43c2.svg";